import { useQuery } from 'react-query'
import { CheckboxGroup, Checkbox, Stack, Spinner, Text } from '@chakra-ui/react'
import { getInternalTags, InternalTag } from '../../api/admin/Events'

interface Props {
  value: string[]
  onChange: (ids: string[]) => void
}

const InternalTagMultiSelect = ({ value, onChange }: Props) => {
  const tags = useQuery(['getInternalTagsActive'], () =>
    getInternalTags({ is_active: true, page_size: 100 })
  )

  if (tags.isLoading) return <Spinner size='sm' />
  // Backend pagination shape: { data: [...], count: N }
  const items: InternalTag[] = tags.data?.data ?? tags.data?.results ?? []

  if (items.length === 0) {
    return <Text variant='detail'>No internal tags yet — create some under Admin → Events → Tags.</Text>
  }

  return (
    <CheckboxGroup value={value} onChange={(v) => onChange((v as string[]).map(String))}>
      <Stack direction='row' wrap='wrap'>
        {items.map((t) => (
          <Checkbox key={t.id} value={t.id}>
            {t.name}
          </Checkbox>
        ))}
      </Stack>
    </CheckboxGroup>
  )
}

export default InternalTagMultiSelect
